import { PennButton } from "@/components/ui/button/PennButton";

type FloatingCompareCTAProps = {
  count: number;
  onCompare: () => void;
};

export const FloatingCompareCTA = ({ count, onCompare }: FloatingCompareCTAProps) => {
  if (count === 0) return null;

  return (
    <div className="fixed bottom-6 right-4 sm:right-6 z-30">
      <PennButton variant="primary" size="lg" onClick={onCompare} className="rounded-2xl whitespace-nowrap">
        Compare / Configure<span className="hidden sm:inline"> Solutions</span>
        <span className="inline-flex items-center justify-center rounded-full bg-white/15 px-2 py-0.5 text-xs font-bold">
          {count}
        </span>
      </PennButton>
    </div>
  );
};
